module.exports = {
  title: "产业学院运门户",
  /**
   * @type {boolean} true | false
   * @description Whether show the settings right-panel
   */
  showSettings: false,
  errorLog: "production",
  previewPath: "http://192.168.1.150:8067/",
  recruitBaseUrl: "https://recruit.ve-city.com",
  setChatText: false // 控制聊天按钮是否显示
};
